<template>
  <van-row>
    <van-col span="4">
      <van-sidebar v-model="active" @change="onChange">
        <van-sidebar-item title="我的跟进" disabled />
        <van-sidebar-item title="客户列表"/>
        <van-sidebar-item title="出诊安排" disabled/>
        <van-sidebar-item title="互动留言" disabled/>
      </van-sidebar>
    </van-col>
    <van-col span="20" offset="0">
      <van-list>
        <van-cell-group
          inset
          v-for="(wxUserInfoVo, id) in wxUserInfoVoList.wxUserInfoVo"
          :key="id"
          :title="wxUserInfoVo.realName"
        >
          <van-field
            v-model="wxOpenId"
            label="客户编号"
            :placeholder="wxUserInfoVo.wxOpenId"
            label-align="right"
            readonly
          />
          <van-field
            v-model="mobile"
            error
            label="手机号"
            :placeholder="wxUserInfoVo.mobile"
            label-align="right"
            readonly
          />
          <van-field
            v-model="age"
            error
            label="年龄"
            :placeholder="wxUserInfoVo.age"
            label-align="right"
            readonly
          />
          <van-field
            v-model="sex"
            error
            label="性别"
            :placeholder="wxUserInfoVo.sex"
            label-align="right"
            readonly
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                @click="findData(wxUserInfoVo.wxOpenId)"
                >更多</van-button
              >
            </template>
          </van-field>
        </van-cell-group>
      </van-list></van-col>
  </van-row>
  <!--van-pagination v-model="currentPage" :page-count="12" mode="simple" /-->
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import { getCheckDoctorBinding, postWxUserInfoVoData } from "../../api/doctor";
import { showDialog } from "vant";
import { useRouter } from "vue-router";
import { postUserLog } from "../../api/userlog";
export default {
  setup() {
    const active = ref(0);
  
    //const currentPage = ref(1);
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const wxUserInfoVoList = reactive({
      wxUserInfoVo: {
        id: "",
        wxOpenId: "",
        realName: "",
        mobile: "",
        hospitalName: "",
        orderId: "",
        age: "",
        sex: "",
      },
    });
    const onChange = (index) => {
      if(index==1){
        router.push('/doctorIndex');
      }else if(index==2){
        router.push('/doctorWork');
      }
    }
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      getCheckDoctorBinding().then((res1) => {
        console.log(res1.data.code);
        const binding = res1.data.code;
        if (binding == 70001) {
          console.log("进入医生服务");
          postWxUserInfoVoData().then((res) => {
            console.log(res.data.data);
            wxUserInfoVoList.wxUserInfoVo = res.data.data;
          });
        } else {
          showDialog({
            title: "错误提醒",
            message: "您尚未开通医生服务功能！这部分功能仅为医生提供服务使用",
            theme: "round-button",
          }).then(() => {
            router.push("/about");
          });
        }
      });
    });
    return {
      active,
      onChange,
      //currentPage,
      wxUserInfoVoList,
    };
  },
  methods: {
    findData(id) {
      this.$router.push("/userHealthDes/" + id);
    },
  },
};
</script>
<style scoped>
/* 调整图像大小(最好用百分比) */
.van-card-img {
  width: 40% !important;
  height: 40% !important;
}

.text2DIndentation {
  font-size: 12px;
  text-align: left;
  margin-left: 2em;
}

.text3DIndentation {
  font-size: 12px;
  text-align: left;
  text-indent: 1em;
}
</style>
